function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  width: 48,
  height: 48,
  rx: 24,
  fill: "#00B900"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.564 29.8084L12.5 36L19.22 34.2319C20.859 35.095 22.7252 35.5862 24.7069 35.5862C31.22 35.5862 36.5 30.3062 36.5 23.7931C36.5 17.28 31.22 12 24.7069 12C18.1938 12 12.9138 17.28 12.9138 23.7931C12.9138 25.9912 13.5167 28.0469 14.564 29.8084ZM29.7975 25.4389C29.7975 25.4389 31.8196 26.6239 32.3679 27.6601C32.6012 28.1005 32.52 28.6418 32.1675 28.9951L31.435 29.7276C29.1112 32.0513 26.4879 30.9071 24.1641 28.5834L22.0404 26.4597L19.9166 24.336C17.5929 22.0123 16.4487 19.389 18.7724 17.0653L19.5049 16.3328C19.8574 15.9803 20.3987 15.8986 20.8395 16.132C21.8758 16.6803 23.0608 18.7023 23.0608 18.7023C23.3216 19.1598 23.3508 19.7115 22.8858 19.9727C22.8858 19.9727 22.0979 20.6298 21.9845 20.7969C21.4675 21.5602 21.4875 22.2673 22.2012 22.981L23.86 24.6397L25.5187 26.2985C26.2325 27.0122 26.9396 27.0322 27.7029 26.5151C27.87 26.4018 28.5271 25.6139 28.5271 25.6139C28.7879 25.1489 29.34 25.1781 29.7975 25.4389Z",
  fill: "white"
});

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.13f6d75d.svg";
export { ForwardRef as ReactComponent };